import React from "react";
import FooterSubscribe from "../Footer/FooterSubscribe";
import "./SubscribePage.css";

function SubscribePage() {
  return (
    <div className="subscribe-page">
      <FooterSubscribe />
    </div>
  );
}

export default SubscribePage;

